export const savedFiltersFeatureKey ='savedFiltersFeatureKey';